
import {is_production_mode} from "../client/helper/execute-mode";

const LOWERCASE = "abcdefghijklmnopqrstuvwxyz";
const UPPERCASE = LOWERCASE.toUpperCase();
const DIGITS = "0123456789";
const SPECIAL_CHARACTERS = ".,<>!@#$%^&*()+=_-[]{}";
const PASSWORD_LENGTH = 8

const MIN_LENGTH_ERROR = "Password must be 8 characters or longer.";
const NO_LOWERCASE_CHARACTERS = "Password must contain a lowercase character.";
const NO_UPPERCASE_CHARACTERS = "Password must contain an uppercase character.";
const NO_NUMBERS = "Password must contain a number.";
const NO_SPECIAL_CHARACTERS = "Password must contain a special character.";

const string_contains = (str, characters) => {

  for(let i=0; i < characters.length; i++) {
    if (str.includes(characters.charAt(i))) {
      return true;
    }
  }
  return false;
};

/**
 * {@param passwd} has to have at least 12 characters,
 * upper and lower case letters, special characters and
 * numbers.
 */
const valid_password_prod = passwd => {
  if (passwd.length < PASSWORD_LENGTH) {
    return {
      valid: false,
      error: MIN_LENGTH_ERROR,
    }
  }

  if (!string_contains(passwd, LOWERCASE)) {
    return {
      valid: false,
      error: NO_LOWERCASE_CHARACTERS,
    }
  }

  if (!string_contains(passwd, UPPERCASE)) {
    return {
      valid: false,
      error: NO_UPPERCASE_CHARACTERS,
    }
  }

  if (!string_contains(passwd, DIGITS)) {
    return {
      valid: false,
      error: NO_NUMBERS,
    }
  }

  if (!string_contains(passwd, SPECIAL_CHARACTERS)) {
    return {
      valid: false,
      error: NO_SPECIAL_CHARACTERS,
    }
  }

  return { valid: true };
};

const PASSWORD_LENGTH_DEV = 6;
const PASSWORD_TOO_SHORT_DEV = "Password must be longer than 6 characters.";

const valid_password_dev = password => {

  if (password.length < PASSWORD_LENGTH_DEV) {
    return {
      valid: false,
      error: PASSWORD_TOO_SHORT_DEV,
    }
  }

  return { valid: true };
}

const valid_password = (config, password) => {
  if (is_production_mode(config)) {
    return valid_password_prod(password);
  }
  return valid_password_dev(password);
}

export { valid_password, valid_password_prod, valid_password_dev };
